/** Tailwind `md` breakpoint — sidebar visible by default at desktop widths only. */
const DESKTOP_MIN_WIDTH_PX = 768;
const DESKTOP_MEDIA_QUERY = `(min-width: ${DESKTOP_MIN_WIDTH_PX}px)`;

/**
 * Mobile: closed until menu tap. Desktop: open by default.
 */
export function getInitialSidebarOpen(
  matchesMediaQuery: (query: string) => boolean = defaultMatchesMediaQuery,
): boolean {
  return matchesMediaQuery(DESKTOP_MEDIA_QUERY);
}

function defaultMatchesMediaQuery(query: string): boolean {
  if (typeof window === 'undefined') return false;
  return window.matchMedia(query).matches;
}
